import { GalleryItemProps } from './gallery-item.type';
import styles from './gallery-item.module.css';
import { GalleryItemPlaceholder } from './gallery-item-placeholder';
import { GalleryItemType } from '@topshots/core-models';

export const GalleryItem = ({
  item,
  onItemClicked,
  ...props
}: GalleryItemProps) => {
  return (
    <div
      {...props}
      onClick={() => {
        onItemClicked?.(item);
      }}
      className={styles.galleryItem}
    >
      {item.imageUrl && item.imageUrl !== '' ? (
        <img className={styles.image} src={item.imageUrl} alt={item.id} />
      ) : (
        <GalleryItemPlaceholder />
      )}
      <div className={styles.galleryItemTitle}>{item.title}</div>
    </div>
  );
};
